var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmlFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6188 6.02197H8.49688L7.01251 8.23135L5.52813 6.02197H3.40626L5.93438 9.80322L3.08438 14.022H7.01251V12.597H6.22813L7.01251 11.4313L8.75626 14.022H10.9406L8.08751 9.80322L10.6188 6.02197Z",
    fill: "#CAD0E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3531 3.60625C13.0031 3.14062 12.5094 2.5875 11.9844 2.03437C11.4594 1.48125 10.9094 1.01562 10.4125 0.665625C9.6 0.0875 9.22188 0 8.99062 0H1.25312C0.553125 0 0 0.553125 0 1.25V14.75C0 15.4469 0.553125 16 1.25 16H12.7406C13.4375 16 13.9906 15.4469 13.9906 14.75V5.03125C14.0219 4.8 13.9344 4.42188 13.3531 3.60625ZM11.2875 2.7625C11.7812 3.25625 12.1312 3.66562 12.4219 4.04375H10.0062V1.62812C10.3562 1.89062 10.7937 2.26875 11.2875 2.7625ZM13.0062 14.7781C13.0062 14.925 12.8906 15.0406 12.7437 15.0406H1.25312C1.10625 15.0406 0.990625 14.925 0.990625 14.7781V1.28125C0.990625 1.13437 1.10625 1.01875 1.25312 1.01875H8.99062V4.50938C8.99062 4.77187 9.22187 5.00313 9.48437 5.00313H12.975V14.7781H13.0062Z",
    fill: "#CAD0E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlFile);
export default __webpack_public_path__ + "static/media/xmlFile.1dc3a69a3e18b275ef4856d13b0ab66d.svg";
export { ForwardRef as ReactComponent };